import { useHseSummary } from "@dashboard/hooks/useHseSummary";
import { faLightbulbOn } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { StatCard } from "./StatCard";

export default function YourOpportunities() {
    const { t } = useTranslation();
    const { data: summary, isPending, isError } = useHseSummary();

    const linkHref =
        summary && !Array.isArray(summary.links) ? summary.links.opportunities : undefined;

    return (
        <StatCard
            label={t("common.yourOpportunities")}
            value={summary?.metrics.opportunities.total}
            isPending={isPending}
            isError={isError}
            icon={faLightbulbOn}
            variant="pink"
            linkHref={linkHref}
            linkLabel={t("dashboard.manageOpportunities")}
        />
    );
}
